<template>
  <section
    id="our-work"
    :class="[
      'our-work-section tw-relative apTablet3:tw-flex tw-justify-center tw-bg-black tw-z-[10]',
      'tw-transition-opacity tw-duration-500 tw-ease',
      'apTablet3:tw-py-[160px] tw-pb-[141px] apTablet:tw-py-[120px]',
      { 'tw-overflow-hidden': props.gridItems.length < 5 }
    ]"
  >



    <!-- <img :class="[
      'tw-absolute tw-left-[-150px] tw-bottom-[256px] tw-z-[-1]',
      'tw-w-[542px] apTablet3:tw-hidden'
    ]" :src="$cdn('images/home/striped_hexagon.png')" /> -->

    <!-- Image stuck to the top of the section -->
    <img
      :src="topRectangle"
      alt="Top Rectangle"
      class="tw-w-[120px] tw-top-[-50px] tw-h-[160px] tw-flex-shrink-0 tw-absolute tw-z-[50]"
      :style="{ left: `${boxPadLeft}px` }"
    >

    <div class="apTablet3:tw-max-w-[1280px] apTablet3:tw-mx-[48px] tw-mx-6 desktop:tw-mx-[80px] tw-flex tw-flex-col">

      <!-- Title and Description Section -->
      <div class="tw-mx-auto">
        <h1
          class="tw-text-white apTablet3:tw-text-h4-bold-desktop-800 tw-text-h4-bold-mobile-800 tw-uppercase apTablet3:tw-w-[645px] tw-w-[342px]  tw-pb-[33px] tw-pt-6"
        >
          Our Work
        </h1>
        <p
          class="tw-text-ap-snow apTablet3:tw-text-body-desktop tw-text-body-mobile apTablet3:tw-w-[640px] desktop:tw-w-[584px] tw-w-[342px]"
        >
          From FMCG to government agencies, see how Next has transformed
          creative ideas into impactful digital experiences, driving success for
          our clients.
        </p>
      </div>
      <div
        class="tw-flex tw-flex-row tw-gap-4 apTablet3:tw-gap-[80px] tw-pt-[80px] apTablet3:tw-pt-[160px]"
      >
        <!-- Left Items Section -->
        <div
          class="tw-w-1/2 tw-flex tw-flex-col tw-relative tw-z-[9999999] tw-gap-[80px] apTablet3:tw-gap-[160px]"
        >
          <div
            v-for="(item, index) in leftItem"
            :id="item.slug"
            :key="index"
            class="tw-relative tw-z-10 tw-overflow-hidden tw-transition-transform tw-duration-300"
          >
            <a href="#" class="tw-cursor-pointer" @click.prevent="handleWorkOnClick(item)">
              <div class="tw-overflow-hidden apTablet3:tw-mb-10 tw-mb-6 apTablet3:tw-h-[800px] tw-h-auto">
                <img
                  :src="cdn(item.overview.banner)"
                  :alt="item.overview.title"
                  class="tw-w-full tw-min-h-[217px] apTablet:tw-min-h-[395px] tw-block tw-transition-transform tw-duration-300 tw-h-full tw-object-cover apTablet3:hover:tw-scale-110"
                  loading="lazy"
                >
              </div>
              <p
                class="tw-text-ap-white apTablet3:tw-text-body-md-desktop tw-text-label-md-mobile "
              >
                {{ item.overview.title }}
              </p>
              <p
                class="tw-text-ap-very-light-grey apTablet3:tw-text-h4-bold-desktop tw-text-body-bold-mobile apTablet3:tw-py-4 tw-py-2"
              >
                {{ item.overview.subtitle }}
              </p>
            </a>
          </div>
          <img
            id="rotating-hexagon-image"
            :src="rotatingHexagon"
            alt="Rotating Hexagon"
            class="tw-absolute tw-right-[250px] tw-top-[740px] tw-w-[560px] tw-h-[560px] tw-z- apTablet3:tw-block tw-hidden"
          >
        </div>

        <!-- Right Items Section -->
        <div
          class="tw-w-1/2 tw-flex tw-flex-col tw-relative tw-gap-[80px] apTablet3:tw-gap-[160px] tw-pt-[109px] apTablet3:tw-pt-[400px]"
        >
          <div
            v-for="(item, index) in rightItem"
            :id="item.slug"
            :key="index"
            class="tw-relative tw-z-10 tw-overflow-hidden tw-transition-transform tw-duration-300"
          >
            <a href="#" class="tw-cursor-pointer" @click.prevent="handleWorkOnClick(item)">
              <div class="tw-overflow-hidden apTablet3:tw-mb-10 tw-mb-6 apTablet3:tw-h-[800px] tw-h-auto">
                <img
                  :src="cdn(item.overview.banner)"
                  :alt="item.overview.title"
                  class="tw-w-full tw-min-h-[217px] apTablet:tw-min-h-[395px] tw-block tw-transition-transform tw-duration-300 tw-h-full tw-object-cover apTablet3:hover:tw-scale-110"
                  loading="lazy"
                >
              </div>
              <p
                class="tw-text-ap-white apTablet3:tw-text-body-md-desktop tw-text-label-md-mobile "
              >
                {{ item.overview.title }}
              </p>
              <p
                class="tw-text-ap-very-light-grey apTablet3:tw-text-h4-bold-desktop tw-text-body-bold-mobile apTablet3:tw-py-4 tw-py-2"
              >
                {{ item.overview.subtitle }}
              </p>
            </a>
          </div>

          <!-- Rotating Circle Image Section -->
          <img
            id="rotating-circle-image"
            :src="rotatingCircle"
            alt="Rotating Circle"
            :class="[
              'tw-absolute tw-w-[600px] tw-h-[600px] tw-z-0 tw-object-contain',
              'tw-min-w-[381px]',
              'apTablet3:tw-top-[140px] apTablet3:tw-left-[190px]',
              'apTablet:tw-top-[-200px] apTablet:tw-right-[30%]',
              'tw-top-[-240px] tw-right-[-200px]',
            ]"
          >
        </div>
      </div>
      <!-- Items Section -->
      <!-- apTablet3:tw-text-body-desktop tw-text-body-mobile tw-mx-auto dark:tw-text-white tw-text-ap-nero apTablet3:tw-w-[640px] tw-w-full tw-mx-auto -->

      <!-- Work Modal -->
      <TeleportModal v-if="modalWorkOpened" v-model:visible="modalWorkOpened">
        <div class="tw-flex tw-flex-col tw-overflow-y-auto scrollbar-hide apTablet3:tw-px-20 apTablet:tw-px-16 tw-px-6 tw-pb-8 tw-w-full">
          <WorkModalContent :data="modalWorkData" />
        </div>
      </TeleportModal>
    </div>
  </section>
</template>

<script setup lang="ts">
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { Work } from '../../model/interfaces/WorkInterface';
import { cdn } from '../../support/cdn';
import TeleportModal from '../shared/TeleportModal.vue';
import WorkModalContent from './work-modal-content.vue';
gsap.registerPlugin(ScrollTrigger);

const boxPadLeft = ref(640);

const props = defineProps({
  darkMode: {
    type: Boolean,
    default: true,
  },
  gridItems: {
    type: Array as () => Work[],
    default: () => {
      return [];
    },
  },
});

/**
 * Handle Work onClick
 */
const modalWorkOpened = ref(false);
const modalWorkData = ref();
function handleWorkOnClick(item: Work) {
  modalWorkData.value = item;
  if (modalWorkData.value === undefined) {
    return;
  }
  // Open modal
  document.body.style.overflow = 'hidden';
  modalWorkOpened.value = true;
}

const emit = defineEmits();
const topRectangle = cdn('images/home/top_rectangle.png');
const rotatingCircle = cdn('images/home/striped_circle.png');
const rotatingHexagon = cdn('images/home/striped_hexagon.png');

const leftItem: any[] = [];
const rightItem: any[] = [];


props.gridItems.forEach((item: any, index) => {
  if (index % 2 === 0) {
    leftItem.push(item); // Even index, add to leftItem
  } else {
    rightItem.push(item); // Odd index, add to rightItem
  }
});

function onResize() {
  if (window.innerWidth > 1024) {
    boxPadLeft.value = (window.innerWidth - 640) / 2;
  }
}

function initAnimation() {

  if (window.innerWidth < 1025) return;

  const element1 = document.getElementById('rotating-circle-image');
  const baseElementId = document.getElementById('our-work');
  const baseElement = document.querySelector('.our-work-section');
  const element2 = document.getElementById('rotating-hexagon-image');

  if (!element1 && !baseElement) return;

  // Create the observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {

          let refDarkMode = document.documentElement.classList.contains('dark');
          // Trigger GSAP animation when the element is in the viewport
          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: element1,
              scrub: true, // Smooth scrolling
              start: 'top bottom', // Animation starts when the element's top reaches the center
              // markers: true, // Enable for debugging
            },
          });

          // First animation: Zoom out and rotate 30 degrees
          timeline.fromTo(
            element1,
            {
              scale: 1.5, // Start with 150% zoom
              rotate: 0, // Start with no rotation
            },
            {
              scale: 1, // Zoom out to original size
              rotate: -15, // Rotate to 30 degrees
              duration: 1, // Adjust duration for timing
              ease: 'ease-in-out', // Smooth in-and-out transition
            }
          );

          // Second animation: Continue rotating to 60 degrees and move up by 100px
          timeline.to(element1, {
            rotate: -90, // Additional rotation to 60 degrees
            y: 1200,
            duration: 2, // Control the timing of this phase
            ease: 'linear', // Maintain consistent movement
          });

          const timeline2 = gsap.timeline({
            scrollTrigger: {
              trigger: element2,
              scrub: true, // Smooth scrolling
              start: 'top bottom', // Animation starts when the element's top reaches the center
              // markers: true, // Enable for debugging
            },
          });

          timeline2.to(element2, {
            rotate: 120,
            y: 1200,
            duration: 2, // Control the timing of this phase
            ease: 'linear', // Maintain consistent movement
          });

          ScrollTrigger.create({
            trigger: baseElementId,
            start: 'top top',
            end: 'bottom top',
            // markers: true,
            onEnter: () => {
              refDarkMode = document.documentElement.classList.contains('dark');
              if (!refDarkMode) {
                document.documentElement.classList.add('dark');
              }
            },
            onLeaveBack: () => {
              if (!refDarkMode) {
                // document.documentElement.classList.remove("dark");
              }
            },
            onEnterBack: () => {
              refDarkMode = document.documentElement.classList.contains('dark');
              if (!refDarkMode) {
                document.documentElement.classList.add('dark');
              }
            },
            onLeave: () => {
              if (!refDarkMode) {
                // document.documentElement.classList.remove("dark");
              }
            }

          });

          // Disconnect the observer after initializing the animation
          observer.disconnect();
        }
      });
    },
    { threshold: 0 } // Trigger when 50% of the element is visible
  );

  // Observe the element
  if (element1) {
    observer.observe(element1);
  }
}

onMounted(() => {
  onResize();
  checkParams();
  window.addEventListener('resize', onResize);
  initAnimation();
  //   props.gridItems.forEach((item: any) => {
  //     const selector = document.getElementById(item.slug);
  //     gsap.fromTo(
  //       selector,
  //       {
  //         opacity: 0,
  //       },
  //       {
  //         opacity: 1,
  //         scrollTrigger: {
  //           trigger: selector,
  //           start: "top 75%",
  //           toggleActions: "play none none none",
  //           onEnter: () => {
  //             emit("end-animation");
  //           },
  //         },
  //       }
  //     );
  //   });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});

function checkParams() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('works')) {
    const works = params.get('works');
    scrollToSection('our-work', works);
    setTimeout(() => {
      if (works.length > 0) {
        const work = props.gridItems.find((item) => item.slug === works);
        if (work) {
          handleWorkOnClick(work);
        }
      }else{
        window.history.replaceState({}, '', '/work');
      }
    }, 1000);
  }
}

const scrollToSection = (section: string, subsection: string | null) => {
  const element = document.getElementById(section);
  const subElement = document.getElementById(subsection);
  if (element) {
    requestAnimationFrame(() => {
      const rect = element.getBoundingClientRect();
      const y = rect.top + window.scrollY;

      gsap.to(window, {
        scrollTo: { y },
        duration: 1,
        ease: 'power2.out',
        onComplete: () => {
          if (subElement) {
            subElement.scrollIntoView({ behavior: 'smooth' });
          }else {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    });
  }
};
</script>

<style scoped>
.modal-container {
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.4s ease-out, opacity 0.3s ease-out;
}

.modal-container.show {
  transform: translateY(0);
  opacity: 1;
}
</style>